/*
 * @Author: 刘玉田
 * @Date: 2021-06-25 15:37:13
 * @Last Modified by: 刘玉田
 * @Last Modified time: 2021-06-25 15:43:14
 * MV
 */

import { PageContainer } from "components/PageContainer";
import { FlexBoxCenter } from "style";

export const MV = () => {
  return (
    <PageContainer isLoading={false}>
      <FlexBoxCenter>MV页面开发中</FlexBoxCenter>
    </PageContainer>
  );
};
